<template>
  <v-dialog 
    v-model="dialog" 
    fullscreen 
    persistent 
    transition="fade-transition"
    content-class="loading-dialog-pro"
  >
    <v-card class="loader-wrapper d-flex flex-column align-center justify-center">
      <div class="background-blobs">
        <div class="blob orange"></div>
        <div class="blob brown"></div>
      </div>

      <div class="glass-container d-flex flex-column align-center">
        
        <div class="loader-stack mb-10">
          <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="orbit-svg">
            <circle cx="50" cy="50" r="46" stroke="rgba(186, 107, 48, 0.08)" stroke-width="0.5" fill="none" />
            
            <g class="loading-steer">
              <circle cx="50" cy="4" r="3" fill="#BA6B30" /> <circle cx="62" cy="7" r="2.2" fill="#BA6B30" opacity="0.7" />
              <circle cx="73" cy="14" r="1.8" fill="#BA6B30" opacity="0.4" />
              <circle cx="82" cy="24" r="1.2" fill="#BA6B30" opacity="0.2" />
              <circle cx="88" cy="36" r="0.8" fill="#BA6B30" opacity="0.1" />
            </g>
            
            <g class="loading-steer-reverse">
              <circle cx="50" cy="96" r="1.5" fill="#BA6B30" opacity="0.3" />
              <circle cx="38" cy="93" r="1" fill="#BA6B30" opacity="0.1" />
            </g>
          </svg>

          <div class="bear-overlay">
            <img 
              src="@/assets/bear-face-icon-2.png" 
              alt="Oso Legor" 
              class="bear-img-loading"
            />
          </div>
        </div>
        
        <div class="loader-text text-center">
          <h2 class="text-h4 font-weight-black white--text tracking-tighter mb-1">
            LEGOR<span class="brand-accent">ERP</span>
          </h2>
          
          <div class="status-wrapper">
            <transition name="slide-fade" mode="out-in">
              <span :key="statusText" class="typing-text">{{ statusText }}</span>
            </transition>
          </div>
        </div>

        <div class="progress-track mt-10">
          <div class="progress-fill"></div>
        </div>

        <div class="mt-8 text-overline grey--text text--darken-2 tracking-widest">
          SISTEMA PROTEGIDO
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LoadingNew',
  data: () => ({
    dialog: true,
    statusText: 'Iniciando sistemas...',
    texts: [
      'Sincronizando base de datos...',
      'Cargando módulos core...',
      'Verificando seguridad...',
      'Preparando entorno...',
      'Bienvenido'
    ],
    textIndex: 0,
    interval: null
  }),
  mounted() {
    this.interval = setInterval(() => {
      this.textIndex = (this.textIndex + 1) % this.texts.length;
      this.statusText = this.texts[this.textIndex];
    }, 2500);
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  }
}
</script>

<style scoped>
/* Contenedor Principal */
.loader-wrapper { 
  background: #050505 !important; 
  overflow: hidden; 
  position: relative; 
}

.glass-container {
  background: rgba(255, 255, 255, 0.01);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 60px;
  border-radius: 40px;
  z-index: 10;
  width: 90%;
  max-width: 450px;
  box-shadow: 0 25px 50px rgba(0,0,0,0.5);
}

/* Sistema de Órbitas */
.loader-stack {
  position: relative;
  width: 220px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.orbit-svg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.bear-overlay {
  z-index: 5;
  width: 110px;
}

.bear-img-loading {
  width: 100%;
  filter: drop-shadow(0 10px 30px rgba(0,0,0,0.8));
  animation: bear-work 1.8s ease-in-out infinite;
}

/* Animaciones de Carga (Estela) */
.loading-steer {
  animation: rotate-loading 1.6s cubic-bezier(0.42, 0, 0.58, 1) infinite;
  transform-origin: 50% 50%;
}

.loading-steer-reverse {
  animation: rotate-loading 3s linear infinite reverse;
  transform-origin: 50% 50%;
  opacity: 0.4;
}

@keyframes rotate-loading {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes bear-work {
  0%, 100% { 
    transform: scale(1); 
    filter: brightness(1) drop-shadow(0 10px 30px rgba(0,0,0,0.8)); 
  }
  50% { 
    transform: scale(1.07); 
    filter: brightness(1.2) drop-shadow(0 0 25px rgba(186, 107, 48, 0.4)); 
  }
}

/* Barra de progreso inferior */
.progress-track {
  width: 120px;
  height: 2px;
  background: rgba(255,255,255,0.05);
  border-radius: 10px;
  overflow: hidden;
}

.progress-fill {
  width: 40%;
  height: 100%;
  background: #BA6B30;
  box-shadow: 0 0 15px #BA6B30;
  animation: scan-progress 1.5s ease-in-out infinite;
}

@keyframes scan-progress {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(300%); }
}

/* Tipografía */
.brand-accent { color: #BA6B30; }
.typing-text { 
  color: rgba(255,255,255,0.4); 
  font-size: 0.85rem; 
  letter-spacing: 3px;
  text-transform: uppercase;
  font-weight: 300;
}

/* Blobs de fondo para profundidad */
.blob { position: absolute; border-radius: 50%; filter: blur(100px); opacity: 0.1; }
.blob.orange { width: 450px; height: 450px; background: #BA6B30; top: -10%; left: -10%; }
.blob.brown { width: 550px; height: 550px; background: #3d2a20; bottom: -10%; right: -10%; }

/* Clases de transición */
.slide-fade-enter-active { transition: all .3s ease; }
.slide-fade-leave-active { transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0); }
.slide-fade-enter, .slide-fade-leave-to { transform: translateY(10px); opacity: 0; }

::v-deep .loading-dialog-pro { box-shadow: none !important; }
</style>